const ko = {}, jp = {}, ja = {
'해당 작업의 권한이 없습니다.':'その操作の権限がありません。',
'로그인':'ログイン',
'아이디':'ID',
'비밀번호':'パスワード',
'인증번호':'認証番号',
'음성듣기':'音声を聞く',
'새로고침':'リフレッシュ',
'비밀번호 찾기':'パスワードを忘れた方',
'아이디 찾기':'IDを忘れた方',
'동의':'同意',
'취소':'キャンセル',
'서비스 이용 동의':'サービス利用の同意',
'수정':'修正',
'도장/서명':'印鑑/署名',
'내 정보 수정':'マイプロフィール編集',
'권한':'権限',
'그룹':'グループ',
'연락처':'連絡先',
'발효일':'発酵日',
'도장/서명 추가':'塗装/署名の追加',
'로그인 처리중':'ログイン処理中',
'개인도장추가':'個人印鑑追加',
'e-봉투 만들기':'e-封筒の作成',
'진행상태':'進行状況',
'폴더이동':'フォルダ移動',
'템플릿 선택':'テンプレート選択',
'템플릿':'テンプレート',
'검색':'検索',
'템플릿 업로드':'テンプレートアップロード',
'템플릿 csv':'テンプレートcsv',
'대상폴더명':'対象フォルダ名',
'폴더 순서변경':'フォルダの順序変更',
'드래그하여 순서조정':'ドラッグして順序調整',
'이력':'歴史',
'e-봉투':'e-封筒',
'수신함':'受信箱',
'발신함':'受信箱',
'임시 보관함':'一時保管箱',
'휴지통':'ごみ箱',
'휴지통 이동':'ごみ箱移動',
'신규 생성':'新規作成',
'기존 사용자 선택':'既存のユーザー選択',
'내 폴더':'マイフォルダ',
'목록이 없습니다.':'結果がありません。',
'상세 검색':'詳細検索',
'초기화':'初期化',
'검색 유형':'検索タイプ',
'날짜 범위':'日付範囲',
'금액 범위':'金額範囲',
'검색어':'検索語',
'검색어 포함':'検索語含む',
'날짜 범위지정':'日付範囲指定',
'금액 범위지정':'金額範囲指定',
'폴더가 비어있습니다.':'フォルダが空です。',
'$건 중 $건 완료':'$件中$件完了',
'템플릿 만들기':'テンプレート作成',
'저장':'保存',
'전체 템플릿':'全体テンプレート',
'즐겨찾기':'お気に入り',
'임시 템플릿':'一時テンプレート',
'삭제 템플릿':'削除テンプレート',
'내 템플릿':'私のテンプレート',
'공유 템플릿':'共有テンプレート',
'조직 템플릿':'組織テンプレート',
'자식템플릿 추가':'子テンプレートの追加',
'템플릿명':'テンプレート名',
'설명':'説明',
'참여자 상세설정':'参加者の詳細設定',
'수행업무':'実行業務',
'e-봉투 개봉방법':'e-封筒の開封方法',
'e-봉투 조회권한':'e-封筒の閲覧権限',
'확인자 추가':'確認者追加',
'확인자':'確認者',
'메시지 사용':'メッセージの使用',
'회람 완료 시':'回覧完了時',
'메시지':'メッセージ',
'문서 추가':'文書追加',
'문서명, 파일, 등록자':'文書名、ファイル、登録者',
'문서':'文書',
'전체 문서':'全文書',
'삭제 문서':'削除文書',
'조직 문서':'組織文書',
'PW 변경':'PW変更',
'PW':'PW',
'PW 확인':'PW確認',
'버전':'バージョン',
'종류':'種類',
'문서명':'文書名',
'문서명 보조':'文書名補助',
'문서 설명':'文書説明',
'PDF 추가':'PDF追加',
'신규버전 추가':'新しいバージョン追加',
'회사도장추가':'会社塗装追加',
'이메일 스타일':'メールスタイル',
'회사도장 추가':'会社塗装追加',
'회사도장 수정':'会社塗装修正',
'조직 관리':'組織管理',
'설정':'設定',
'조직영문명':'組織英語名',
'OFAC Check':'OFAC Check',
'GCIF':'GCIF',
'FAX':'FAX',
'사업자등록번호':'事業者登録番号',
'총괄관리자':'総括管理者',
'기본발신자':'基本発信者',
'발신자명':'発信者名',
'조직로고':'組織ロゴ',
'조직로고 파일':'組織ロゴファイル',
'도장명':'印鑑名',
'삭제':'削除',
'복제':'複製',
'통계':'統計',
'내 정보 변경':'マイプロフィール変更',
'관리자 / 메인 전환':'管理者/メイン切り替え',
'로그아웃':'ログアウト',
'조직':'組織',
'Product':'プロダクト',
'상세설정':'詳細設定',
'목록으로':'リストに',
'작성':'作成',
'다운로드':'ダウンロード',
'반려':'差し戻し',
'참여자 추가':'参加者追加',
'일전':'前日',
'일 경과':'日経過',
'만료일':'有効期限',
'만료 알림':'有効期限通知',
'미확인 시 알림':'未確認時のお知らせ',
'서명 권한 위임':'署名権限委任',
'보안등급':'セキュリティ評価',
'TAG':'タグ',
'문서 비밀번호 확인':'文書のパスワード確認',
'등록완료된 문서는 수정이 불가합니다.':'登録済みの文書は修正できません。',
'이전 버전':'以前のバージョン',
'파일':'ファイル',
'문서 수정':'文書編集',
'작성완료':'作成完成',
'이미지 업로드':'画像のアップロード',
'크롭할 범위를 드래그하세요':'クロップする範囲をドラッグしてください',
'저장 및 사용':'保存及び使用',
'도장 만들기':'印鑑作成',
'한글 1~16자 입력':'ハングル1〜16文字入力',
'사인 만들기':'サイン作成',
'여기에 서명하세요':'ここに署名してください',
'진행중':'進行中',
'필수 입력값이 누락되었습니다.':'必須項目が入力されていません',
'알림':'お知らせ',
'작성완료 하시겠습니까?':'作成完成しますか？',
'반려사유':'差し戻し理由',
'모달 팝업 샘플':'モーダルポップアップサンプル',
'개발표준':'開発標準',
'일반':'一般',
'체크박스':'チェックボックス',
'라디오':'ラジオ',
'입력폼':'入力フォーム',
'관리자 화면':'管理者画面',
'비밀번호를 확인하세요':'パスワードを確認してください',
'비밀번호를 입력하세요':'パスワードを入力してください',
'$ 일전':'$日前',
'$ 일 경과':'$日経過',
'가능':'可能',
'불가능':'不可能',
'첨부문서':'添付文書',
'참여자 역할':'参加者の役割',
'역할':'役割',
'참여자':'参加者',
'성명':'氏名',
'작성완료방법':'作成完了方法',
'순서대로 서명':'順番に署名',
'영구삭제':'完全削除',
'배정해제':'割り当て解除',
'$ 명':'$ 名',
'CCIF':'CCIF',
'Cust Abbr.':'Cust Abbr.',
'Product/수행업무':'Product/遂行業務',
'[$] 문서를 $ 했습니다.':'[$] 文書を$しました。',
'e-봉투 유효기간':'e-封筒の有効期限',
'e-봉투명':'e-封筒名',
'e-봉투ID':'e-封筒ID',
'e-봉투에 반영':'e-封筒に反映',
'감사추적인증서':'監査追跡証明書',
'개인도장':'個人スタンプ',
'개인도장 수정':'個人スタンプを修正',
'관리':'管理',
'관리자 전용':'管理者専用',
'구분':'区分',
'권한 관리':'権限管理',
'권한 추가':'権限を追加',
'권한명':'権限名',
'권한삭제':'権限を削除',
'그룹/멤버':'グループ/メンバー',
'그룹 관리':'グループ管理',
'그룹 권한':'グループ権限',
'그룹 수정':'グループを修正',
'그룹 추가':'グループを追加',
'그룹/멤버 배정':'グループ/メンバーを割り当て',
'그룹명':'グループ名',
'그룹별로 선택한항목을 입력받습니다.':'グループごとに選択した項目を入力してもらいます',
'금액을 입력받습니다.':'金額を入力してもらいます',
'기존 비밀번호':'既存のパスワード',
'날짜를 입력받습니다.':'日付を入力してもらいます',
'내 템플릿 만들기':'マイテンプレートを作成',
'복사':'コピー',
'붙여넣기':'ペースト',
'잘라내기':'カット',
'다음 참여자 추가':'次の参加者を追加',
'다음단계':'次の段階',
'닫기':'閉じる',
'대량발송':'大量発送',
'대상그룹':'対象グループ',
'돌아가기':'戻る',
'드롭다운중 선택한값을 입력받습니다.':'ドロップダウンの中から選択した値を入力してもらいます',
'등록된 정보가 없습니다.<br>내 정보 변경에서 추가 가능합니다.':'登録された情報がありません。 <br>個人情報の変更から追加できます',
'등록자':'登録者',
'등록자\n등록일':'登録者\n登録日',
'마스킹 해제 요청':'マスキング解除要請',
'마지막로그인':'最終ログイン',
'멤버 Product/수행업무 배정':'メンバーProduct/遂行業務を割り当て',
'멤버 관리':'メンバー管理',
'멤버 배정':'メンバーを割り当てる',
'멤버 추가':'メンバーを追加',
'목록':'リスト',
'목록을 검색중 입니다.':'リストを検索中です',
'문서 변환 중...':'文書変換中···',
'문서를 가져오는데 실패했습니다.<br>($)':'ドキュメントの読み込みに失敗しました。 <br>($)',
'동일한 템플릿을 선택하세요.':'同じテンプレートを選択してください。',
'문서명, 문서명보조, 원본파일명':'文書名、文書名補助、原本ファイル名',
'미리보기':'プレビュー',
'키표시':'キー表示',
'발신자':'発信者',
'발송일':'発送日',
'비고':'備考',
'비밀번호 변경':'パスワードを変更',
'비밀번호 확인':'パスワード確認',
'사용자 관리':'ユーザー管理',
'사용자 수정':'ユーザーを修正',
'사용자 추가':'ユーザーを追加',
'사용자명':'使用者名',
'사용자명, 아이디, 이메일':'ユーザー名、ID、e-mail',
'사용자명, 아이디, 이메일, 연락처':'ユーザー名、ID、e-mail、連絡先',
'사용자영문명':'使用者 英文名',
'사용자이미지':'ユーザーイメージ',
'사용자이미지 추가':'ユーザーイメージを追加',
'사인패드를 열어 드로잉 합니다.':'サインパッドを開いてドローイングします。',
'상태':'状態',
'영문자, 숫자 포함시 10 ~ 30자리입니다.<br>영문자,숫자, 특수문자 포함시 8 ~ 30자리입니다.<br>특수문자는 @, _, -, ., $, !, %, *, #, ?, &가 가능합니다.':'パスワードは10～30文字で、英数字を含む必要があります。<br>パスワードは8～30文字で、英数字と特殊文字を含む必要があります。<br>使用可能な特殊文字: @, _, -, ., $, !, %, *, #, ?, &',
'새 비밀번호':'新しいパスワード',
'새 비밀번호 확인':'新しいパスワードの確認',
'선택':'選択',
'전체선택':'すべて選択',
'이동':'移動',
'빠른이동':'クイックムーブ',
'설정안함':'設定しない',
'숫자(-포함)를 입력받습니다.':'数字（-含む）を入力してもらいます',
'신규멤버 추가':'新規メンバーを追加',
'해당 항목을 $ 처리하시겠습니까?':'その項目を$処理しますか？',
'언어':'言語',
'업무상태':'業務状態',
'위임자 추가':'委任者を追加',
'이전단계':'前段階',
'인증서':'証明書',
'인증코드':'認証コード',
'일':'業務',
'임시저장':'一時保存',
'자동생성':'自動生成',
'작성자':'作成者',
'잠금':'ロック',
'저장 후 닫기':'保存して閉じる',
'저장된(업로드한) 도장 이미지를 선택 합니다.':'保存された(アップロードされた)スタンプ画像を選択します',
'조직 추가':'組織追加',
'조직도 선택':'組織図を選択',
'조직로고 파일추가':'組織ロゴファイルを追加',
'조직명':'組織名',
'조직명, 영문명, Cusr Abbr.':'組織名、英語名、Cusr Abbr.',
'조직명, 영문명, Cusr Abbr., 총괄관리자':'組織名、英語名、Cusr Abbr.、総括管理者',
'조직상세':'組織詳細',
'조직선택':'組織を選択',
'주소':'住所',
'진행':'進行',
'최종등록일':'最終登録日',
'최종수정일':'最終修正日',
'최종수정자':'最終修正者',
'추가':'追加',
'캡챠인증에 실패하였습니다.':'キャプチャ認証に失敗しました',
'텍스트를 입력받습니다.':'テキストを入力してもらいます',
'템플릿 수정':'テンプレートを修正',
'템플릿 추가':'テンプレートを追加',
'템플릿에 반영':'テンプレートに反映',
'템플릿저장':'テンプレートを保存',
'템플릿키':'テンプレートキー',
'파일명':'ファイル名',
'파일을 첨부하고 링크를 삽입합니다.':'ファイルを添付し、リンクを挿入します',
'파일추가':'ファイルを追加',
'해제 사유':'解除事由',
'확인란 체크여부를 입력받습니다.':'確認欄のチェック可否を入力してもらいます',
'회사도장':'会社塗装',
'회사도장 배정':'会社のスタンプを振り分ける',
'확인': '確認',
'[$] 템플릿을 $ 했습니다.':'[$] テンプレートを $ しました',
'e-봉투ID, e-봉투명, 참여자, 발신자, 태그':'e-封筒ID、e-封筒名、参加者、発信者、タグ',
'OFAC Check 여부':'OFAC Check 可否',
'개인도장 추가':'個人印章を追加',
'개인정보 처리방침':'個人情報処理方針',
'개인정보공개':'個人情報の公開',
'개인정보공개 여부':'個人情報の公開可否',
'개체의 x좌표값을 입력합니다. (◀▶방향키)':'個体のx座標値を入力します(◀▶方向キー)',
'개체의 y좌표값을 입력합니다. (▲▼방향키)':'個体のy座標値を入力します(▲▼方向キー)',
'굵은 글씨체 여부 속성값 입니다.':'太字の可否の属性値です',
'권한 수정':'権限修正',
'글씨체 속성값 입니다.':'書体の属性値です',
'글자 색상 입니다.':'文字の色です',
'기본':'基本',
'내용을 입력합니다.':'内容を入力します',
'대리인 등록':'代理人登録',
'대표 이메일':'代表e-mail',
'도장 이미지':'印章イメージ',
'마스킹 해제':'マスキング解除',
'미즈호전자계약플랫폼(MeDP) 개인정보 처리방침':'みずほ電子契約プラットフォーム(MeDP)個人情報処理方針',
'발송':'発送',
'발신자\n발송일':'発信者\n発送日',
'배정 가능 사용자':'割り当て可能使用者',
'법인으로 등록된 도장/서명을 사용합니다.':'法人で登録された印章・署名を使用します',
'사용자':'ユーザー',
'사용자 배정':'ユーザーを割り当てる',
'사용자 선택':'ユーザーを選択',
'사용자아이디':'ユーザーID',
'삭제하시겠습니까?':'削除しますか？',
'상세':'詳細',
'상위템플릿':'上位テンプレート',
'생성일':'作成日',
'생성자':'作成者',
'서명':'署名',
'서비스 동의':'サービス同意',
'선택값들을 입력합니다.':'選択値を入力します',
'인증방법 선택':'認証方法を選択',
'인증번호 항목을 입력하세요':'認証番号の項目を入力してください',
'인증번호를 다시 입력해 주세요.':'再度認証コードを入力してください。',
'입력값을 좌측정렬로 표시합니다.':'入力値を左整列に表示します',
'입력하지 않으면 문서를 제출할 수 없습니다.':'入力しないと文書を提出できません',
'조직 상세 조회':'組織詳細を照会',
'조직 수정':'組織修正',
'조직, 사용자명, 아이디, 이메일, 연락처':'組織、ユーザー名、ID、e-mail、連絡先',
'조직명, 영문명, Cust Abbr.':'組織名、英文名、Cust Abbr',
'첨부파일':'添付ファイル',
'총괄관리자 추가':'総括管理者を追加',
'크기(배율 30~300%)를 입력합니다. (+-키)':'サイズ(倍率30~300％)を入力します(+-キー)',
'키값이 입력되면 해당키로 사용자 입력값이 서버에 저장됩니다.':'キー値が入力されると、該当キーでユーザーの入力値がサーバーに保存されます',
'템플릿명, 템플릿키, 등록자':'テンプレート名、テンプレートキー、登録者',
'할당된 법인 도장/서명이 없습니다.':'割り当てられた法人印章・署名がありません',
'회 이상':'回以上',
'활성':'活性化',
'비활성':'無効前',
'$ 형식을 확인하세요.':'$形式を確認してください。',
'입력값이 최대 길이를 초과했습니다. (최대: $)':'入力値が最大長を超えています。（最大：$）',
'미입력 또는 잘못 입력된 항목이 있습니다.<br>(왼쪽 상단 <i class="bi bi-bell-fill fs-3 text-danger"></i> 아이콘을 클릭하여 자세한 내용을 확인해 주세요.)':'未入力または誤入力の項目があります。<br>左上のアイコン<i class="bi bi-bell-fill fs-3 text-danger"></i>をクリックして、詳細を確認してください。',
'유효성 검사':'バリデーション',
'메시지 전달이 필요할 경우 대상자를 선택하세요.':'メッセージを配信する必要がある場合は、対象ユーザーを選択します。',
'작성 화면으로 이동합니다.':'作成画面に移動します。',
'기본정보':'基本情報',
'문서정보':'文書情報',
'다운로드 가능한 목록이 없습니다.':'ダウンロード可能なリストはありません。',
'멤버':'メンバー',
'퇴사':'退社',
'오류횟수 초기화':'パスワードのエラー回数初期化',
'비밀번호 초기화':'パスワード初期化',
'인쇄':'印刷',
'e-봉투 다운로드':'e-封筒ダウンロード',
'메시지를 입력하세요.':'メッセージを入力してください。',
'대상자를 선택하세요.':'対象者を選択してください。',
'작성 하시겠습니까?':'書きたいですか？',
'수정 하시겠습니까?':'編集しますか?',
'검색어를 입력하세요.':'検索語を入力してください。',
'시작범위와 종료범위를 입력하세요.':'開始範囲と終了範囲を入力してください。',
'시작범위가 종료범위보다 큽니다.':'開始範囲が終了範囲よりも大きい。',
'로그인 실패 횟수':'ログイン失敗回数',
'로그인\n실패 횟수':'ログイン\n失敗回数',
'로그인 실패 횟수 초과':'ログイン失敗回数を超えました',
'조직명, Cust Abbr., 사용자명, 아이디, 이메일, 그룹명':'組織名、Cust Abbr、ユーザー名、ID、e-mail、グループ名',
'조직명, 그룹명':'組織名、グループ名',
'템플릿명 항목을 입력하세요.':'テンプレート名フィールドを入力します。',
'문서를 추가하세요.':'ドキュメントを追加します。',
'참여자를 추가하세요.':'参加者を追加します。',
'역할명을 입력하세요.':'ロール名を入力します。',
'폴더를 선택하세요.':'フォルダーを選択します。',
'참여자를 선택하세요.':'参加者を選択してください。',
'제거':'除去',
'계정 삭제 시, 모든 데이터가 영구 삭제되는 것에 동의합니다.':'アカウントを削除すると、すべてのデータが永久に削除されることに同意します。',
'사용자 아이디를 변경하시겠습니까?':'ユーザーIDを変更しますか？',
'변경 시 모든 데이터가 새 아이디로 업데이트됨을 이해하고, 아이디 변경에 동의합니다.':'変更時にすべてのデータが新しいIDに更新されることを理解し、IDの変更に同意します。',
'마스킹을 해제하고 수행해주세요.':'マスキングを解除して、進めてください。',
'총괄관리자를 배정 해제 하시겠습니까?':'マスター管理者の割り当てを解除しますか?',
'총괄관리자를 영구 삭제 하시겠습니까?':'マスター管理者を完全に削除しますか?',
'메뉴':'メニュー',
'참여자 정보':'参加者情報',
'e-봉투 메뉴':'e-封筒メニュー',
'템플릿 메뉴':'テンプレートメニュー',
'문서 메뉴':'文書メニュー',
'문서 목록':'文書リスト',
'멤버 목록':'メンバーリスト',
'이전 항목':'前の項目',
'다음 항목':'次の項目',
'기본 정보': '基本情報',
'크기 및 위치, 스타일': 'サイズ、位置、スタイル',
'입력 관련': '入力関連',
'기타': 'その他',
'키값': 'キー値',
'컬럼명': 'カラム名',
'탭키순서': 'タブキー順序',
'필수항목': '必須項目',
'선택값': '選択値',
'선택항목': '選択項目',
'x좌표': 'X座標',
'y좌표': 'Y座標',
'글씨체': 'フォント',
'글자크기': 'フォントサイズ',
'글자색상': '文字色',
'굵은글씨': '太字',
'정렬': '整列',
'회사': '会社',
'날짜': '日付',
'금액': '金額',
'최대길이': '最大長',
'사전 입력값': '事前入力値',
'입력내용': '入力内容',
'툴팁': 'ツールチップ',
'한글제외': '韓国語除外',
'읽기전용': '読み取り専用',
'개인정보': '個人情報',
'키': 'キー',
'표시값': 'ラベル',
'맑은고딕': 'Malgun Gothic',
'굴림': 'Gulim',
'돋움': 'Dotum',
'바탕': 'Batang',
'Meiryo UI': 'MeiryoUI',
'MS Mincho': 'MSMincho',
'Arial': 'Arial',
'Noto Sans': 'Noto Sans',
'사인': 'サイン',
'도장': '印',
'전자서명': '電子署名',
'전자 디지털 서명': '電子デジタル署名',
'이름': '名前',
'이메일': 'Eメール',
'숫자':'数字',
'텍스트': 'テキスト',
'체크박스': 'チェックボックス',
'드롭다운': 'ドロップダウン',
'라디오버튼': 'ラジオボタン',
'파일첨부': 'ファイル添付',
'메모': 'メモ',
'넓이': '幅',
'높이': '高さ',
'회전': '回転',
'실행취소': '元に戻す',
'재실행': 'やり直し',
'확대': 'ズームイン',
'축소': 'ズームアウト',
'넓이에 맞춤': '幅に合わせる',
'높이에 맞춤': '高さに合わせる',
'그룹화':'グループ化',
'왼쪽 맞춤': '左寄せ',
'가운데 맞춤': '中央揃え',
'오른쪽 맞춤': '右寄せ',
'위쪽 맞춤': '上揃え',
'중간 맞춤': '中央揃え',
'아래쪽 맞춤': '下揃え',
'저장 및 닫기':'保存して閉じる',
'탭키순서를 부여하시겠습니까?<br>이 작업을 수행하면 전체 탭키 순서가 위치 기준으로 재조정됩니다.':'タブキーの順序を設定しますか？<br>この操作を実行すると、全体のタブキーの順序が位置に基づいて再調整されます。',
'탭키 순서가 자동으로 부여되었습니다.':'タブキーの順序が自動的に設定されました。',
'그룹화 하였습니다.': 'グループ化が完了しました。',
'전체제거': 'すべて削除',
'전체제거하시겠습니까?': 'すべて削除しますか？',
'$건':'$件',
'키값이 중복됩니다.':'キーの値が重複しています。',
'템플릿 설계가 올바르지 않습니다.<br>(왼쪽 상단 <i class="bi bi-bell-fill fs-3 text-danger"></i> 아이콘을 클릭하여 자세한 내용을 확인해 주세요.)': 'テンプレート設計が正しくありません。<br>左上のアイコン<i class="bi bi-bell-fill fs-3 text-danger"></i>をクリックして、詳細を確認してください。',
'경고가 발생했습니다. 그래도 저장하시겠습니까?<br>(왼쪽 상단 <i class="bi bi-bell-fill fs-3 text-danger"></i> 아이콘을 클릭하여 자세한 내용을 확인해 주세요.)': '警告が発生しましたが、それでも保存しますか？<br>左上のアイコン<i class="bi bi-bell-fill fs-3 text-danger"></i>をクリックして、詳細を確認してください。',
'[$] 키값이 중복됩니다.': '[$] キー値が重複しています。',
'[$] 선택항목이 없습니다.': '[$] 選択肢がありません。',
'[$] 키값 중 누락된 항목이 있습니다.': '[$] キー値の中に欠落している項目があります。',
'[$] 표시값 중 누락된 항목이 있습니다.': '[$] 表示されている値の中に欠落している項目があります。',
'[$] 동일한 키가 존재합니다.': '[$] 同じキーが存在します。',
'[$] 선택값이 없습니다.': '[$] 選択値がありません。',
'[$] 동일한 선택값이 존재합니다.': '[$] 同じ選択値が存在します。',
'[$] 필수여부가 다른 항목이 있습니다.': '[$] 必須要件が異なる項目があります。',
'$번째': '$th',
'성공': '成功',
'실패': '失敗',
'링크 참여 시 위임자를 추가할 수 없습니다.':'リンク参加時に代理人を追加することはできません。',
'링크 참여 시 추가 참여자를 등록할 수 없습니다.':'リンク参加時に追加参加者を登録することはできません。',
'마지막 옵션은 삭제할 수 없습니다.':'最後のオプションは削除できません。',
'요청일':'リクエスト日',
'확인일':'チェック日',
'잘라내기되었습니다.':'カットしました。',
'복사되었습니다.':'コピーしました。',
'붙여넣었습니다.':'ペーストしました。',
'전체 폼 컨트롤':'すべてのフォームコントロール',
'페이지의 가장 아래에 도달했습니다.':'Reached the bottom of the page.',
'자동완성':'自動入力',
'선택항목 자동완성 실패 텍스트를 확인해주세요.':'選択項目のオートコンプリート失敗テキストを確認してください。',
'선택항목을 자동완성하였습니다.':'選択項目が自動入力されました。',
'e-봉투ID, e-봉투명':'e-封筒ID、e-封筒名',
'전체 조직':'全組織',
'전체 상태':'全てのステータス',
'템플릿명, 템플릿키':'テンプレート名、テンプレートキー',
'전송 활성화': '送信の有効化',
'전송 시작일': '送信開始日',
'최종 요청일': '最終リクエスト日',
'전송 대상 건': '対象文書数',
'전송 요청 건': 'リクエスト文書数',
'전송 완료 건': '完了文書数',
'e-봉투 발신자':'E-エンベロープ送信者',
'입력한 텍스트가 최대 크기를 초과했습니다.<br>(초과된 텍스트는 제대로 표시되지 않을 수 있습니다.)':'入力したテキストが最大サイズを超えました。<br>(超過したテキストは正しく表示されない可能性があります。)',
'이메일을 입력하세요.':'メールアドレスを入力してください。',
}, en = {
'해당 작업의 권한이 없습니다.':'You do not have permission for that operation.',
'로그인':'Sign in',
'아이디':'ID',
'비밀번호':'Password',
'인증번호':'Certification Number',
'음성듣기':'Listen to voice',
'새로고침':'Refresh',
'비밀번호 찾기':'Find password',
'아이디 찾기':'Find ID',
'동의':'Agree',
'취소':'Cancel',
'서비스 이용 동의':'Consent to use of service',
'수정':'Modify',
'도장/서명':'Stamp/Signature',
'내 정보 수정':'Edit my profile',
'권한':'Permission',
'그룹':'Group',
'사용자영문명':'User English name',
'연락처':'Contact',
'발효일':'Effective date',
'도장/서명 추가':'Add stamp/signature',
'로그인 처리중':'Login in process',
'개인도장추가':'Add personal stamp',
'e-봉투 만들기':'Create E-envelope',
'진행상태':'Status',
'폴더이동':'Folder move',
'템플릿 선택':'Choose template',
'템플릿':'Template',
'검색':'Search',
'템플릿 업로드':'Upload template',
'템플릿 csv':'Template csv',
'대상폴더명':'Target folder name',
'폴더 순서변경':'Change folder order',
'드래그하여 순서조정':'Reorder by dragging',
'e-봉투':'E-envelope',
'수신함':'Inbox',
'발신함':'Outbox',
'임시 보관함':'Drafts',
'휴지통':'Trash',
'내 폴더':'My folder',
'목록이 없습니다.':'No results.',
'상세 검색':'Advanced Search',
'초기화':'Reset',
'검색 유형':'Search type',
'날짜 범위':'Date range',
'금액 범위':'Amount range',
'검색어':'Search text',
'폴더가 비어있습니다.':'Folder is empty.',
'$건 중 $건 완료':'$ out of $ completed',
'템플릿 만들기':'Create template',
'저장':'Save',
'전체 템플릿':'All template',
'즐겨찾기':'Favorites',
'임시 템플릿':'Temporary template',
'삭제 템플릿':'Delete template',
'내 템플릿':'My template',
'공유 템플릿':'Shared template',
'조직 템플릿':'Organization template',
'자식템플릿 추가':'Add child template',
'템플릿명':'Template name',
'설명':'Explanation',
'참여자 상세설정':'Participant detail settings',
'수행업무':'Performed task',
'e-봉투 개봉방법':'E-envelope Opening Method',
'e-봉투 조회권한':'E-envelope Viewing Permission',
'확인자 추가':'Add confirmer',
'메시지 사용':'Use Messages',
'회람 완료 시':'Upon completion of circulation',
'메시지':'Message',
'문서 추가':'Add document',
'문서명, 파일, 등록자':'Document name, file, registrant',
'문서':'Document',
'전체 문서':'All document',
'삭제 문서':'Delete document',
'조직 문서':'Organization document',
'PW 변경':'Change PW',
'PW':'PW',
'PW 확인':'Check PW',
'버전':'Version',
'종류':'Type',
'문서명':'Document name',
'문서명 보조':'Document Name Assistance',
'문서 설명':'Document description',
'PDF 추가':'Add PDF',
'신규버전 추가':'Add new version',
'회사도장추가':'Add company seal',
'이메일 스타일':'Email style',
'회사도장 추가':'Add company seal',
'회사도장 수정':'Change company seal',
'회사도장':'Company seal',
'조직 관리':'Organization management',
'설정':'Setting',
'조직영문명':'Organization English name',
'OFAC Check':'OFAC Check',
'GCIF':'GCIF',
'FAX':'FAX',
'사업자등록번호':'Company Registration Number',
'총괄관리자':'Security Administrator',
'기본발신자':'Default sender',
'발신자명':'Sender name',
'조직로고':'Organization logo',
'조직로고 파일':'Organization logo file',
'도장명':'Seal name',
'삭제':'Delete',
'복제':'Clone',
'통계':'Statistics',
'내 정보 변경':'Change my profile',
'관리자 / 메인 전환':'Toggle administrator / main',
'로그아웃':'Sign out',
'조직':'Organization',
'Product':'Product',
'상세설정':'Detailed setting',
'목록으로':'Show list',
'작성':'Write',
'다운로드':'Download',
'반려':'Reject',
'참여자 추가':'Add Participant',
'일전':'Days before',
'일 경과':'Days after',
'만료일':'Expiration date',
'만료 알림':'Expiration notification',
'미확인 시 알림':'Notify me if unconfirmed',
'서명 권한 위임':'Delegate signing authority',
'보안등급':'Security Rating',
'TAG':'TAG',
'문서 비밀번호 확인':'Confirm document password',
'등록완료된 문서는 수정이 불가합니다.':'Documents that have been registered cannot be edited.',
'이전 버전':'Previous version',
'문서 수정':'Edit document',
'작성완료':'Completed',
'이미지 업로드':'Image upload',
'크롭할 범위를 드래그하세요':'Drag the area to crop',
'저장 및 사용':'Storage and use',
'도장 만들기':'Stamp making',
'한글 1~16자 입력':'Enter 1~16 Korean characters',
'사인 만들기':'Make a signature',
'여기에 서명하세요':'Please sign here',
'진행중':'Processing',
'필수 입력값이 누락되었습니다.':'A required input is missing.',
'알림':'Notification',
'작성완료 하시겠습니까?':'Are you sure you want to complete?',
'반려사유':'Reason for rejection',
'사용자 추가':'Add user',
'모달 팝업 샘플':'Modal popup sample',
'개발표준':'Development standard',
'일반':'Common',
'체크박스':'Checkbox',
'라디오':'Radio',
'입력폼':'Input form',
'관리자 화면':'Administrator screen',
'비밀번호를 확인하세요':'Please check your password',
'$ 일전':'$ days ago',
'$ 일 경과':'$ days after',
'가능':'Possible',
'불가능':'Impossible',
'첨부문서':'Attachments',
'참여자 역할':'Participant role',
'역할':'Role',
'참여자':'Participants',
'성명':'Name',
'작성완료방법':'How to complete writing',
'순서대로 서명':'Signign order',
'사용자명, 아이디, 이메일':'User name, ID, e-mail',
'사용자명, 아이디, 이메일, 연락처':'User name, ID, e-mail, contact information',
'상세':'Detail',
'템플릿명, 템플릿키, 등록자':'Template name, template key, registrant',
'$ 명':'$ name',
'CCIF':'CCIF',
'Cust Abbr.':'Cust Abbr.',
'Product/수행업무':'Product/Performance work',
'[$] 문서를 $ 했습니다.':'[$] Document was $.',
'e-봉투 유효기간':'Expiration date of E-envelope',
'e-봉투명':'E-envelope name',
'e-봉투ID':'E-envelope ID',
'e-봉투에 반영':'Reflect on E-envelope',
'감사추적인증서':'Audit trail certificate',
'개인도장':'Personal stamp',
'개인도장 수정':'Edit personal stamp',
'관리':'Mange',
'관리자 전용':'Administrator only',
'구분':'Category',
'권한 관리':'Manage permission',
'권한 추가':'Add permission',
'권한명':'Permission name',
'권한삭제':'Delete permission',
'그룹/멤버':'Group/member',
'그룹 관리':'Manage group',
'그룹 권한':'Group permission',
'그룹 수정':'Edit group',
'그룹 추가':'Add group',
'그룹/멤버 배정':'Assign group/member',
'그룹별로 선택한항목을 입력받습니다.':'Receive input items selected by each group.',
'금액을 입력받습니다.':'Receive input amount.',
'기존 비밀번호':'Previous password',
'날짜를 입력받습니다.':'Input date.',
'내 템플릿 만들기':'Create my template',
'복사':'Copy',
'붙여넣기':'Paste',
'잘라내기':'Cut',
'다음 참여자 추가':'Add next participants',
'다음단계':'Next step',
'닫기':'Close',
'대량발송':'Mass sending',
'대상그룹':'Target group',
'돌아가기':'Return',
'드롭다운중 선택한값을 입력받습니다.':'Select value from the drop-down.',
'등록된 정보가 없습니다.<br>내 정보 변경에서 추가 가능합니다.':'There is no registered information. <br> You can add it in the Edit my profile.',
'등록자':'Registrant',
'등록자\n등록일':'Registrant \n registration date',
'마스킹 해제 요청':'Masking removal request',
'마지막로그인':'Last sign in',
'멤버 Product/수행업무 배정':'Assign member Product/performance work',
'멤버 관리':'Manage member',
'멤버 배정':'Assign member',
'멤버 추가':'Add member',
'목록':'List',
'목록을 검색중 입니다.':'Serching the list.',
'문서 변환 중...':'Converting the document...',
'문서를 가져오는데 실패했습니다.<br>($)':'Failed loading the document. <br>($)',
'문서명, 문서명보조, 원본파일명':'Document name, assist document name, original file name',
'미리보기':'Preview',
'키표시':'Show Keys',
'발신자':'Sender',
'발송일':'Send date',
'비고':'Note',
'비밀번호 변경':'Change password',
'비밀번호 확인':'Check password',
'사용자 관리':'Manage user',
'사용자 수정':'Edit user',
'사용자명':'User name',
'사용자이미지':'User image',
'사용자이미지 추가':'Add user image',
'사인패드를 열어 드로잉 합니다.':'Open the signature pad and draw.',
'상태':'Status',
'영문자, 숫자 포함시 10 ~ 30자리입니다.<br>영문자,숫자, 특수문자 포함시 8 ~ 30자리입니다.<br>특수문자는 @, _, -, ., $, !, %, *, #, ?, &가 가능합니다.':'Password must be 10 to 30 characters long, and contain both letters and numbers.<br>Password must be 8 to 30 characters long, and contain letters, numbers, and special characters.<br>Allowed special characters: @, _, -, ., $, !, %, *, #, ?, &',
'새 비밀번호':'New password',
'새 비밀번호 확인':'Check new password',
'설정안함':'Do not set',
'숫자(-포함)를 입력받습니다.':'Input number(-included).',
'신규멤버 추가':'Add new member',
'언어':'Language',
'업무상태':'Work status',
'위임자 추가':'Add delegate',
'이전단계':'Previous step',
'인증서':'Certificate',
'인증코드':'Verification code',
'일':'Work',
'임시저장':'Temporary save',
'자동생성':'Auto-generated',
'작성자':'Writer',
'잠금':'Lock',
'저장 후 닫기':'Save and close',
'저장된(업로드한) 도장 이미지를 선택 합니다.':'Select the saved(uploaded) stamp image.',
'조직 추가':'Add organization',
'조직도 선택':'Select the organization',
'조직로고 파일추가':'Add organization logo file',
'조직명':'Organization name',
'조직명, 영문명, Cust Abbr.':'Organization name, english name, Cust Abbr.',
'조직명, 영문명, Cust Abbr., 총괄관리자':'Organization name, english name, Cust Abbr., security administrator',
'조직상세':'Organization details',
'조직선택':'Select organization',
'주소':'Adress',
'진행':'Proceed',
'최종등록일':'Last registration date',
'최종수정일':'Last modification date',
'최종수정자':'Last modifier',
'추가':'Add',
'캡챠인증에 실패하였습니다.':'CAPCHA verification failed.',
'텍스트를 입력받습니다.':'Input the text.',
'템플릿 수정':'Edit template',
'템플릿 추가':'Add template',
'템플릿에 반영':'Reflect to template',
'템플릿저장':'Save template',
'템플릿키':'Template key',
'파일명':'File name',
'파일을 첨부하고 링크를 삽입합니다.':'Attach the file and add the link.',
'파일추가':'Add file',
'해제 사유':'Reason for removal',
'확인란 체크여부를 입력받습니다.':'Input the confirm checkbox.',
'회사도장 배정':'Assign company stamp',
'확인':'Confirm',
'선택':'Select',
'전체선택':'select All',
'이동':'Move',
'빠른이동':'Quick Move',
'크기':'Size',
'가이드':'Guide',
'좌측정렬':'Align left',
'우측정렬':'Align right',
'그룹명':'Group name',
'[$] 템플릿을 $ 했습니다.':'[$] $ the template',
'OFAC Check 여부':'OFAC Check status',
'개인도장 추가':'Add personal stamp',
'개인정보 처리방침':'Personal information policy',
'개인정보공개':'Open personal information',
'개인정보공개 여부':'Personal information open status',
'개체의 x좌표값을 입력합니다. (◀▶방향키)':'Input the objects x coordinate(◀▶ arrow key)',
'개체의 y좌표값을 입력합니다. (▲▼방향키)':'Input the objects y coodrindate(▲▼arrow key)',
'굵은 글씨체 여부 속성값 입니다.':'This is bold font property',
'권한 수정':'Change permission',
'글씨체 속성값 입니다.':'This is the text font face',
'글자 색상 입니다.':'This is the text color',
'기본':'Basic',
'내용을 입력합니다.':'Input contents',
'대리인 등록':'Add delegate',
'대표 이메일':'Representative email',
'도장 이미지':'Stamp image',
'마스킹 해제':'Remove masking',
'미즈호전자문서플랫폼(MeDP) 개인정보 처리방침':'Personal information policy of Mizuho Electronic Document Platform (MeDP)',
'발송':'Send',
'발신자\n발송일':'Sender\nSent on',
'배정 가능 사용자':'Allocatable user',
'법인으로 등록된 도장/서명을 사용합니다.':'Use stamp/signature registered for corporation',
'사용자':'User',
'사용자 배정':'Assign user',
'사용자 선택':'Select user',
'사용자아이디':'User ID',
'삭제하시겠습니까?':'Do you want to delete?',
'상위템플릿':'Parent template',
'생성일':'Created date',
'생성자':'Creator',
'서명':'Signature',
'서비스 동의':'Agree to service',
'선택값들을 입력합니다.':'Input from selection',
'인증방법 선택':'Select certification method',
'인증번호 항목을 입력하세요':'Input certification number',
'인증번호를 다시 입력해 주세요.':'Please enter the verification code again.',
'입력값을 좌측정렬로 표시합니다.':'Displays the input value in left alignment',
'입력하지 않으면 문서를 제출할 수 없습니다.':'You can not submit the document without inputting.',
'조직 상세 조회':'Show organization detail',
'조직 수정':'Modify organization',
'조직, 사용자명, 아이디, 이메일, 연락처':'Organization, user name, user ID, email, contact',
'조직명, 영문명, Cust Abbr.':'Organiazaation name, English name, Cust Abbr',
'첨부파일':'Attachement file',
'총괄관리자 추가':'Add security administrator',
'크기(배율 30~300%)를 입력합니다. (+-키)':'Input (using + - key) the size ( scale from 30% to 300%)',
'키값이 입력되면 해당키로 사용자 입력값이 서버에 저장됩니다.':'By inputing the key, user input value will be saved in the server with the inputted key.',
'할당된 법인 도장/서명이 없습니다.':'There is no allocated corporate stamp / signature.',
'회 이상':'times or more',
'동일한 템플릿을 선택하세요.':'Select the same template.',
'휴지통 이동':'Move to trash',
'검색어 포함':'Include search text',
'날짜 범위지정':'Set date range',
'금액 범위지정':'set amount range',
'에디터에서 세팅된 키값':'Key value set in the editor',
'[$] 권한을 $ 하시겠습니까?':'[$] Should $ the permission?',
'배정된 멤버':'Assigned member',
'신규 생성':'New Creation',
'기존 사용자 선택':'Existing user selection',
'기존 멤버 선택':'Select previous member',
'투명도':'Transparency',
'배경 투명도':'Background transparency',
'도장 내용 1~$자 입력':'Input stamp information within 1~$ charcter',
'한글 서체':'Korean font face',
'한자 서체':'Chinese charcter font face',
'대표이사 도장':'Chief Executive Officer\'s stamp',
'원형 도장':'Circle stamp',
'타원형 도장':'Oval stamp',
'태블릿':'Tablet',
'모바일':'Mobile',
'첨부문서 추가':'Add attachment file',
'영구삭제':'Delete permanently',
'배정해제':'Unassign',
'이력':'history',
'확인자':'Confirmer',
'비밀번호를 입력하세요':'Please enter a password',
'해당 항목을 $ 처리하시겠습니까?':'Should $ for selected item?',
'e-봉투ID, e-봉투명, 참여자, 발신자, 태그':'E-envelop id, E-envelop, participant, sender, tag',
'활성':'Enable',
'비활성':'Disabled',
'$ 형식을 확인하세요.':'Check your $ format.',
'입력값이 최대 길이를 초과했습니다. (최대: $)':'Input value exceeds the maximum length. (Maximum: $)',
'미입력 또는 잘못 입력된 항목이 있습니다.<br>(왼쪽 상단 <i class="bi bi-bell-fill fs-3 text-danger"></i> 아이콘을 클릭하여 자세한 내용을 확인해 주세요.)':'There are unentered or incorrectly entered items.<br>Click the icon in the top left <i class="bi bi-bell-fill fs-3 text-danger"></i> for more details.',
'유효성 검사':'Validation',
'메시지 전달이 필요할 경우 대상자를 선택하세요.':'If you need to deliver a message, select the target audience.',
'작성 화면으로 이동합니다.':'Go to the creation screen.',
'기본정보':'Basic Information',
'문서정보':'Document information',
'다운로드 가능한 목록이 없습니다.':'There are no downloadable items.',
'검색 결과가 없습니다.':'No results were found for your search.',
'멤버':'Member',
'퇴사':'Resign',
'오류횟수 초기화':'Reset Error count of password',
'비밀번호 초기화':'Reset password',
'인쇄':'Print',
'e-봉투 다운로드':'E-envelope Download',
'메시지를 입력하세요.':'Please enter your message.',
'대상자를 선택하세요.':'Please select a target audience.',
'작성 하시겠습니까?':'Do you want to write?',
'수정 하시겠습니까?':'Do you want to edit it?',
'검색어를 입력하세요.':'Please enter your search term.',
'시작범위와 종료범위를 입력하세요.':'Enter the start range and end range.',
'시작범위가 종료범위보다 큽니다.':'The start range is larger than the end range.',
'로그인 실패 횟수':'Number of login failures',
'로그인\n실패 횟수':'Number of\nlogin failures',
'로그인 실패 횟수 초과':'Login failure count exceeded',
'조직명, Cust Abbr., 사용자명, 아이디, 이메일, 그룹명':'Organiazaation name, Cust Abbr, user name, user ID, email, Group name',
'조직명, 그룹명':'Organiazaation name, Group name',
'템플릿명 항목을 입력하세요.':'Enter the template name field.',
'문서를 추가하세요.':'Add a document.',
'참여자를 추가하세요.':'Add participants.',
'역할명을 입력하세요.':'Enter the role name.',
'폴더를 선택하세요.':'Select a folder.',
'참여자를 선택하세요.':'Please select a participant.',
'제거':'Removal',
'계정 삭제 시, 모든 데이터가 영구 삭제되는 것에 동의합니다.':'I agree that all data will be permanently deleted upon account deletion.',
'사용자 아이디를 변경하시겠습니까?':'Would you like to change your user ID?',
'변경 시 모든 데이터가 새 아이디로 업데이트됨을 이해하고, 아이디 변경에 동의합니다.':'I understand that all data will be updated to the new ID upon change, and I agree to the ID change.',
'마스킹을 해제하고 수행해주세요.':'Please unmask and proceed.',
'총괄관리자를 배정 해제 하시겠습니까?':'Do you want to unassign the Master Administrator?',
'총괄관리자를 영구 삭제 하시겠습니까?':'Do you want to permanently delete the Master Administrator?',
'메뉴':'Menu',
'참여자 정보':'Participant Information',
'e-봉투 메뉴':'E-envelope Menu',
'템플릿 메뉴':'Template Menu',
'문서 메뉴':'Document Menu',
'문서 목록':'Document List',
'멤버 목록':'Member List',
'이전 항목':'Previous Item',
'다음 항목':'Next Item',
'기본 정보': 'Basic Information',
'크기 및 위치, 스타일': 'Size, Position, and Style',
'입력 관련': 'Input Related',
'기타': 'Other',
'키값': 'Key Value',
'컬럼명': 'Column Name',
'탭키순서': 'Tab Index',
'필수항목': 'Required Field',
'선택값': 'Option Value',
'선택항목': 'Options',
'x좌표': 'X Coordinate',
'y좌표': 'Y Coordinate',
'글씨체': 'Font',
'글자크기': 'Font Size',
'글자색상': 'Text Color',
'굵은글씨': 'Bold Text',
'정렬': 'Alignment',
'회사': 'Company',
'날짜': 'Date',
'금액': 'Amount',
'최대길이': 'Max Length',
'사전 입력값': 'Predefined Value',
'입력내용': 'Input Content',
'툴팁': 'Tooltip',
'한글제외': 'Exclude Korean',
'읽기전용': 'Read Only',
'개인정보': 'Personal Information',
'키': 'Key',
'표시값': 'Label',
'맑은고딕': 'Malgun Gothic',
'굴림': 'Gulim',
'돋움': 'Dotum',
'바탕': 'Batang',
'Meiryo UI': 'MeiryoUI',
'MS Mincho': 'MSMincho',
'Arial': 'Arial',
'Noto Sans': 'Noto Sans',
'사인': 'Signature',
'도장': 'Stamp',
'전자서명': 'Digital signature',
'전자 디지털 서명': 'Electronic Digital Signature',
'이름': 'Name',
'이메일': 'Email',
'숫자':'Number',
'텍스트': 'Text',
'체크박스': 'Check Box',
'드롭다운': 'Dropdown',
'라디오버튼': 'Radio Button',
'파일': 'File',
'메모': 'Memo',
'넓이': 'Width',
'높이': 'Height',
'회전': 'Rotate',
'실행취소': 'UnDo',
'재실행': 'ReDo',
'확대': 'Zoom In',
'축소': 'Zoom Out',
'넓이에 맞춤': 'Fit to Width',
'높이에 맞춤': 'Fit to Height', 
'그룹화':'Grouping',
'왼쪽 맞춤': 'Left Align',
'가운데 맞춤': 'Center Align',
'오른쪽 맞춤': 'Right Align',
'위쪽 맞춤': 'Top Align',
'중간 맞춤': 'Middle Align',
'아래쪽 맞춤': 'Bottom Align',
'저장 및 닫기':'Save and Close',
'탭키순서를 부여하시겠습니까?<br>이 작업을 수행하면 전체 탭키 순서가 위치 기준으로 재조정됩니다.':'Would you like to assign the tab order?<br>This action will rearrange the entire tab order based on position.',
'탭키 순서가 자동으로 부여되었습니다.':'The tab order has been automatically assigned.',
'그룹화 하였습니다.': 'Grouping has been completed.',
'전체제거': 'Remove All',
'전체제거하시겠습니까?': 'Do you want to remove all?',
'$건':'$items',
'키값이 중복됩니다.':'Duplicate key value.',
'템플릿 설계가 올바르지 않습니다.<br>(왼쪽 상단 <i class="bi bi-bell-fill fs-3 text-danger"></i> 아이콘을 클릭하여 자세한 내용을 확인해 주세요.)': 'The template design is incorrect.<br>Click the icon in the top left <i class="bi bi-bell-fill fs-3 text-danger"></i> for more details.',
'경고가 발생했습니다. 그래도 저장하시겠습니까?<br>(왼쪽 상단 <i class="bi bi-bell-fill fs-3 text-danger"></i> 아이콘을 클릭하여 자세한 내용을 확인해 주세요.)': 'Warning has occurred. Would you still like to save?<br>Click the icon in the top left <i class="bi bi-bell-fill fs-3 text-danger"></i> for more details.',
'[$] 키값이 중복됩니다.': '[$] key value is duplicated.',
'[$] 선택항목이 없습니다.': '[$] No selection options available.',
'[$] 키값 중 누락된 항목이 있습니다.': '[$] There are missing items among the key values.',
'[$] 표시값 중 누락된 항목이 있습니다.': '[$] There are missing items in the displayed values.',
'[$] 동일한 키가 존재합니다.': '[$] has the same key.',
'[$] 선택값이 없습니다.': '[$] has no selected value.',
'[$] 동일한 선택값이 존재합니다.': '[$] has the same selected value.',
'[$] 필수여부가 다른 항목이 있습니다.': '[$] There are items with different mandatory requirements.',
'$번째': '$番目',
'성공': 'Succeed',
'실패': 'Fail',
'링크 참여 시 위임자를 추가할 수 없습니다.':'You cannot add a delegate when participating via the link.',
'링크 참여 시 추가 참여자를 등록할 수 없습니다.':'You cannot register additional participants when participating via the link.',
'마지막 옵션은 삭제할 수 없습니다.':'The last option cannot be deleted.',
'요청일':'Request Date',
'확인일':'Check Date',
'잘라내기되었습니다.':'Cut.',
'복사되었습니다.':'Copied.',
'붙여넣었습니다.':'Pasted.',
'전체 폼 컨트롤':'All form controls',
'페이지의 가장 아래에 도달했습니다.':'ページの一番下に到達しました。',
'자동완성':'Auto Fill',
'선택항목 자동완성 실패 텍스트를 확인해주세요.':'Please check the text for autocomplete failure on the selected option.',
'선택항목을 자동완성하였습니다.':'The selected items have been auto-completed.',
'e-봉투ID, e-봉투명':'E-envelop id, E-envelop',
'전체 조직':'All Organizations',
'전체 상태':'All Status',
'템플릿명, 템플릿키':'Template name, template key',
'전송 활성화': 'Transmission Activation',
'전송 시작일': 'Transmission Start Date',
'최종 요청일': 'Last Request Date',
'전송 대상 건': 'Target Documents Count',
'전송 요청 건': 'Requested Documents Count',
'전송 완료 건': 'Completed Documents Count',
'e-봉투 발신자':'E-envelope Sender',
'입력한 텍스트가 최대 크기를 초과했습니다.<br>(초과된 텍스트는 제대로 표시되지 않을 수 있습니다.)':'The entered text exceeds the maximum size.<br>(Excess text may not be displayed correctly.)',
'이메일을 입력하세요.':'Please enter an email.',
};

export default { ko, en, ja, jp };